import { posthogInstance } from '@/integrations/posthog'

import type {
  AnalyticsProvider,
  EventProperties,
  UserProperties,
} from '../types'

export class PostHogAnalyticsProvider implements AnalyticsProvider {
  name = 'posthog'

  track(eventName: string, properties?: EventProperties): void {
    posthogInstance.capture(eventName, properties)
  }

  identify(userId: string): void {
    posthogInstance.identify(userId)
  }

  alias(newId: string, previousId?: string): void {
    posthogInstance.alias(newId, previousId)
  }

  setUserProperties(properties: UserProperties): void {
    posthogInstance.setPersonProperties(properties)
  }

  reset(): void {
    posthogInstance.reset()
  }
}
